import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators
{
    public static MatchingPasswords(control: AbstractControl): ValidationErrors | null
    {
        const passwordControl = control.get('password');
        const confirmPasswordControl = control.get('password_confirmation');

        if (!passwordControl || !confirmPasswordControl) {
            return null;
        }

        const password = passwordControl.value;
        const confirmPassword = confirmPasswordControl.value;
        const currentErrors = confirmPasswordControl.errors ?? {};

        if (compare(password, confirmPassword)) {
            confirmPasswordControl.setErrors({...currentErrors, not_matching: true});

            return {not_matching: true};
        }

        if (currentErrors.not_matching) {
            const {not_matching, ...remainingErrors} = currentErrors;
            confirmPasswordControl.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
        }

        return null;
    }
}

function compare(password: string | null, confirmPassword: string | null): boolean
{
    return password !== confirmPassword && confirmPassword !== '';
}